import React from 'react';
import { useFilingContext } from '@/finsight/application/Filings/FilingsContext';
import Paginator from '@dealroadshow/uikit/core/components/Paginator';

const PaginatorContainer = (props) => {
  const {
    paginate,
    setItemsPerPage,
    page,
    perPage,
    totalCount,
  } = useFilingContext();

  return (
    <Paginator
      totalCount={ totalCount }
      page={ page }
      perPage={ perPage }
      onItemsPerPageChange={ (perPage) => setItemsPerPage(perPage.value) }
      onPageChange={ (page) => paginate(page.selected) }
      { ...props }
    />
  );
};

export default PaginatorContainer;
